import { useQuery } from "@tanstack/react-query";
import { getTargetareActivitate } from "@/api/endpoints/targetareTinte";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareActivitate() {
  return useQuery({
    queryKey: queryKeys.targetare.activitate(),
    queryFn: getTargetareActivitate,
    select: (response) => response.data,
    staleTime: 1000 * 60,
    retry: 1,
  });
}
